var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSidebarTestResults(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.025,
    height: 19.031,
    viewBox: "0 0 15.025 19.031",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9835",
    "data-name": "Group 9835",
    transform: "translate(225.873 -17330.846)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "task_FILL0_wght200_GRAD0_opsz48",
    d: "M201.387,234.032A1.382,1.382,0,0,1,200,232.645V217.387A1.382,1.382,0,0,1,201.387,216h7.8a1.3,1.3,0,0,1,.546.116,1.763,1.763,0,0,1,.454.3l3.427,3.427a1.761,1.761,0,0,1,.3.454,1.3,1.3,0,0,1,.116.546v11.805a1.382,1.382,0,0,1-1.387,1.387Zm7.981-14.106v-3.156h-7.981a.663.663,0,0,0-.616.616v15.258a.663.663,0,0,0,.616.616h11.251a.663.663,0,0,0,.616-.616V220.62h-3.192a.7.7,0,0,1-.694-.694Zm-8.6-3.156v0Z",
    transform: "translate(-425.373 17115.346)",
    fill: "#cc56c3",
    stroke: "#cc56c3",
    strokeLinecap: "square",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "approval_delegation_FILL0_wght200_GRAD0_opsz48",
    d: "M90.662,263.578l-2.171-2.171.348-.336,1.823,1.827,3.605-3.59.333.329Z",
    transform: "translate(-309.759 17079.059)",
    fill: "#cc56c3",
    stroke: "#cc56c3",
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarTestResults);
export default __webpack_public_path__ + "static/media/sidebar_test_results.b1478f509e79205b29ec5562cb34116f.svg";
export { ForwardRef as ReactComponent };